export default __webpack_public_path__ + "static/media/python-brands.39775061.svg";